import {httpClient9051} from './';

export const _addPaymentModule = params => {
  return httpClient9051
    .post(`/pay_module_admin/api/add`, { ...params })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getAllPaymentModules = () => {
  return httpClient9051
    .get(`/pay_module_admin/api/get_all_modules`)
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _deletePaymentModules = pay_module_id => {
  console.log(pay_module_id);
  return httpClient9051
    .post(`pay_module_admin/api/delete`, { pay_module_id })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
